<template>
  <div>
    <div class="DataTable">
      <!-- <v-toolbar flat color="white">
        <v-layout row wrap>
          <v-flex xs3>
            <v-text-field
                v-model="search"
                append-icon="search"
                label="Pretraga"
                xs5
                hide-details
            ></v-text-field>
          </v-flex>
        </v-layout>
      </v-toolbar>
      <v-data-table
          :headers="headers"
          :items="items"
          :search="search"
      >-->
      <v-layout column>
        <v-flex style="overflow: auto">
          <v-data-table
            :headers="headers"
            :items="items"
            hide-actions
            class="elevation-1"
            :pagination.sync="pagination"
            v-if="id_tank_phase_wine_blend === 0"
          >
            <template slot="headers" slot-scope="props">
              <tr>
                <th
                  v-for="header in props.headers"
                  :key="header.text"
                  :class="[
                    'column sortable',
                    pagination.descending ? 'desc' : 'asc',
                    header.value === pagination.sortBy ? 'active' : '',
                    header.align === 'left' ? 'text-xs-left' : 'text-xs-center',
                  ]"
                  @click="changeSort(header.value)"
                >
                  <v-icon small v-if="header.sortable !== false"
                    >arrow_upward</v-icon
                  >

                  {{ header.text }}
                </th>
              </tr>
            </template>

            <template slot="items" slot-scope="props">
              <tr>
                <td style="display: none">{{ props.item.id }}</td>
                <template v-if="sarza === '15'">
                  <td
                    v-if="props.item.tankFromBatchInOperations.length > 1"
                    style="text-align: left"
                  >
                    {{ formatImena(props.item) }}
                    <template
                      v-if="props.item.tankFromBatchInOperations !== null"
                    >
                      <v-menu
                        open-on-hover
                        top
                        offset-x
                        nudge-right="20"
                        close-delay="100"
                        v-if="props.item.tankFromBatchInOperations.length > 0"
                      >
                        <template v-slot:activator="{}">
                          <v-icon
                            slot="activator"
                            small
                            class="ml-2"
                            color="teal"
                          >
                            info
                          </v-icon>
                          <span>
                            <v-container style="background-color: white">
                              <div class="DataTable">
                                <v-layout>
                                  <v-flex
                                    xs11
                                    pa-2
                                    style="font-size: 20px !important"
                                  >
                                    Spisak barika
                                  </v-flex>
                                </v-layout>

                                <v-layout column>
                                  <v-flex style="overflow: auto">
                                    <v-data-table
                                      :headers="headers_modal_izabrani_tankovi"
                                      :items="
                                        props.item.tankFromBatchInOperations
                                      "
                                      hide-actions
                                      class="elevation-1"
                                      show-select
                                      dense
                                      select-all
                                      :pagination.sync="pagination"
                                    >
                                      <template
                                        slot="headers"
                                        slot-scope="props_modal"
                                      >
                                        <tr>
                                          <th
                                            style="
                                              text-align: center;
                                              padding: 5px;
                                            "
                                            v-for="header in props_modal.headers"
                                            :key="header.text"
                                          >
                                            {{ header.text }}
                                          </th>
                                        </tr>
                                      </template>
                                      <template
                                        slot="items"
                                        slot-scope="props_modal"
                                      >
                                        <tr>
                                          <td
                                            style="
                                              text-align: center;
                                              padding-left: 5px;
                                              padding-right: 5px;
                                            "
                                            v-if="
                                              props_modal.item.tank
                                                .batchPrefix !== null &&
                                              props_modal.item.tank
                                                .batchPrefix !== ''
                                            "
                                          >
                                            {{
                                              props_modal.item.tank.batchPrefix
                                            }}
                                          </td>
                                          <td
                                            style="
                                              text-align: center;
                                              padding-left: 5px;
                                              padding-right: 5px;
                                            "
                                            v-else
                                          >
                                            -
                                          </td>
                                          <td
                                            style="
                                              text-align: center;
                                              padding-left: 5px;
                                              padding-right: 5px;
                                            "
                                          >
                                            {{ props_modal.item.tank.name }}
                                          </td>
                                          <td
                                            style="
                                              text-align: center;
                                              padding-left: 5px;
                                              padding-right: 5px;
                                            "
                                          >
                                            {{
                                              props_modal.item.tank
                                                .inventoryNumber
                                            }}
                                          </td>
                                          <td
                                            style="
                                              text-align: center;
                                              padding-left: 5px;
                                              padding-right: 5px;
                                            "
                                          >
                                            {{
                                              props_modal.item.tank.capacity +
                                              " " +
                                              props_modal.item.tank
                                                .unitOfMeasure.mark
                                            }}
                                          </td>
                                        </tr>
                                      </template>
                                    </v-data-table>
                                  </v-flex>
                                </v-layout>
                              </div>
                            </v-container>
                          </span>
                        </template>
                      </v-menu>
                    </template>
                  </td>
                  <td
                    style="text-align: left"
                    v-else-if="
                      props.item.tankFromBatchInOperations.length === 1
                    "
                  >
                    <template
                      v-if="
                        props.item.tankFromBatchInOperations[0].tank
                          .inventoryNumber !== null &&
                        props.item.tankFromBatchInOperations[0].tank
                          .inventoryNumber !== ''
                      "
                    >
                      {{
                        props.item.tankFromBatchInOperations[0].tank
                          .batchPrefix +
                        " | " +
                        props.item.tankFromBatchInOperations[0].tank.name +
                        " | " +
                        props.item.tankFromBatchInOperations[0].tank
                          .inventoryNumber
                      }}
                    </template>
                    <template v-else>
                      {{
                        props.item.tankFromBatchInOperations[0].tank
                          .batchPrefix +
                        " | " +
                        props.item.tankFromBatchInOperations[0].tank.name
                      }}
                    </template>
                  </td>
                  <td style="text-align: left" v-else>
                    {{ "Svi barici" }}
                  </td>
                </template>
                <td style="text-align: left">
                  {{
                    props.item.additiv.name +
                    (props.item.additiv.additiveGroup.enumLabel ===
                    "oxygenation"
                      ? " (" +
                        (props.item.macroOxygenation ? "makro" : "mikro") +
                        " oksigenacija)"
                      : "")
                  }}
                </td>
                <td
                  style="text-align: center"
                  v-if="props.item.unitOfMeasure !== null"
                >
                  {{
                    props.item.quantity +
                    " " +
                    props.item.unitOfMeasure.mark.replace("psc", "kom")
                  }}
                </td>
                <td style="text-align: center" v-else>
                  {{ props.item.quantity }}
                </td>
                <td
                  style="text-align: center"
                  v-if="props.item.quantityRelativeUnitOfMeasure !== null"
                >
                  {{
                    props.item.quantityRelative +
                    " " +
                    props.item.quantityRelativeUnitOfMeasure.mark.replace(
                      "psc",
                      "kom"
                    ) +
                    (props.item.additiv.additiveGroup.enumLabel ===
                    "oxygenation"
                      ? "/" + (props.item.oxygenationPerodUnitOfMeasure !== null ? props.item.oxygenationPerodUnitOfMeasure.mark : "" )
                      : "")
                  }}
                </td>
                <td style="text-align: center" v-else>-</td>
                <!-- <td style="text-align:center;">{{ props.item.unitOfMeasure.name }}</td> -->
                <td style="text-align: center">
                  {{
                    formatDateTime(props.item.date) 
                  }}
                </td>
                <td style="text-align: center" v-if="props.item.additiv.additiveGroup.enumLabel ===
                    'oxygenation'">
                  {{
                    proracunajTrajanje(
                          props.item.date,
                          props.item.oxygenationEndDate
                        )
                  }}
                </td>
                <td style="text-align: center" v-else></td>
                <!-- <td style="display:none;">{{ props.item.unitOfMeasure.id }}</td> -->
                <td style="display: none">{{ props.item.additiv.id }}</td>
                <td style="display: none">{{ props.item.description }}</td>

                <td class="DataTable__ButtonHolder">
                  <img
                    class="DataTable__Button"
                    title="Izmena"
                    src="../assets/icons/zatabele/ico-edit2.svg"
                    alt="ulaz-grozdja"
                    @click="editItem(props.item)"
                  />
                  <img
                    class="DataTable__Button"
                    title="Pregled izdantnica"
                    src="../assets/icons/zatabele/ico-add.svg"
                    alt="delete-item"
                    @click="otvoriDialogIzdtnica(props.item)"
                  />
                    <!-- v-if="edit && id_tank_phase_wine_blend === 0" -->
                  <img
                    class="DataTable__Button"
                    title="Brisanje"
                    src="../assets/icons/zatabele/ico-delete2.svg"
                    alt="delete-item"
                    @click="deleteItem(props.item)"
                    v-if="edit && id_tank_phase_wine_blend === 0"
                  />
                </td>
              </tr>
            </template>
            <template slot="no-data">
              <!-- <v-btn color="primary" @click="initialize">Reset</v-btn> -->
              <v-alert
                slot="no-results"
                :value="true"
                color="primary"
                icon="info"
                >Nema podataka.</v-alert
              >
            </template>
            <v-alert
              slot="no-results"
              :value="true"
              color="error"
              icon="warning"
              >Trazili ste "{{ search }}" ali nema rezultata.</v-alert
            >
          </v-data-table>
        </v-flex>
      </v-layout>
    </div>
    <!-- /.DataTable -->

    <TokenComponent ref="frmtoken" />
  </div>
</template>


<script>
import { serverBus } from "../main";
import { readJSON } from "../helpers/Functions";

import TokenComponent from "../components/Token";

export default {
  name: "AddingTable",
  components: {
    TokenComponent,
  },
  props: {
    msg: String,
  },
  data: () => ({
    pagination: {
      sortBy: "name",
      rowsPerPage: 10000000,
    },
    search: "",
    headers: [
      { text: "Dodatak", value: "additiv.name", align: "left" },
      { text: "Količina", value: "quantity", align: "center" },
      { text: "Količina/hl", value: "quantityRelative", align: "center" },
      { text: "Datum", value: "date", align: "center" },
      { text: "", value: "", align: "center", sortable: false },
      { text: "Funkcije", value: "funkcije", sortable: false },
    ],
    headers_sarza: [
      // {
      // 	text: "ID",
      // 	align: "left",
      // 	sortable: true,
      // 	value: "id"
      // },

      {
        text: "Barik",
        value: "tankFromBatchInOperations.tank.name",
        align: "left",
        sortable: false,
      },
      { text: "Dodatak", value: "additiv.name", align: "left" },
      { text: "Količina", value: "quantity", align: "center" },
      { text: "Količina/hl", value: "quantityRelative", align: "center" },
      // { text: "JM", value: "unitOfMeasure.name", align: "left" },
      { text: "Datum", value: "date", align: "center" },
      // {text: "Opis", value: "description"},
      { text: "Funkcije", value: "funkcije", sortable: false },
    ],
    headers_modal_izabrani_tankovi: [
      { text: "Oznaka barika", value: "tankNumberInBatch", align: "center" },
      { text: "Naziv", value: "tank.name", align: "center" },
      {
        text: "Inventarni broj",
        value: "tank.inventoryNumber",
        align: "center",
      },
      { text: "Kapacitet", value: "tank.capacity", align: "center" },
    ],
    items: [],
    sarza: 0,
    editedIndex: -1,
    editedItem: {
      id: 0,
      dodatak: "",
      description: "",
      kolicina: "",
      width: "",
      datum: "",
      unitOfMeasure: "",
    },
    defaultItem: {
      id: 0,
      dodatak: "",
      description: "",
      kolicina: "",
      width: "",
      datum: "",
      unitOfMeasure: "",
    },
    id: 0,
    edit: true,
    id_tank_phase_wine_blend: 0,
  }),
  methods: {
    proracunajTrajanje(datumOd, datumDo) {
      let odgovor = "";

      if (datumDo !== null) {
        const date1 = new Date(datumOd);
        const date2 = new Date(datumDo);

        const diffTime = Math.abs(date2 - date1);
        const diffYears = Math.ceil(diffTime / (1000 * 60 * 60 * 24 * 30 * 12)) - 1;

        const diffMonths = Math.ceil(
          (diffTime - diffYears  * 1000 * 60 * 60 * 24 * 30 * 12) /
            (1000 * 60 * 60 * 24 * 30)
        ) - 1;

        const diffDays = Math.ceil(
          (diffTime -
          diffYears * 1000 * 60 * 60 * 24 * 30 * 12 -
            diffMonths * 1000 * 60 * 60 * 24 * 30) /
            (1000 * 60 * 60 * 24)
        ) - 1;

        odgovor = (diffDays !== 0 ? diffDays + " d " : "")  + (diffMonths !== 0 ? diffMonths + " m " : "") + (diffYears !== 0 ? diffYears + " g" : "");
      }

      return odgovor;
    },
    formatDateTime(date) {
      let lokDate = date.split("T")[0];
      let lokTime = date.split("T")[1];

      let month = lokDate.split("-")[1];
      let day = lokDate.split("-")[2];
      const year = lokDate.split("-")[0];

      let HH = lokTime.split(":")[0];
      let mm = lokTime.split(":")[1];

      return [day, month, year].join(".") + " " + [HH, mm].join(":");
    },
    deleteSifarnik(id) {
      this.$http
        .delete(
          this.globalServiceLocation + this.globalPort + "/add/delete/" + id,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          }
        )
        .then((response) => {
          // // // console.log(response);

          this.getAllSifarnik(true);
        })
        .catch((e) => {
          // // console.log(e.response);

          if (!e.response) {
            alert(
              this.$t("error.message")
            );
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  // // console.log(result);
                  // // console.log("Novi token - " + localStorage.getItem("user-token"));

                  this.$http
                    .delete(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/add/delete/" +
                        id,
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      // // // console.log(response);

                      this.getAllSifarnik(true);
                    })
                    .catch((e) => {
                      // // console.log(e.response);

                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    getAllSifarnik(brisanje) {
      let _this = this;
      this.$http
        .get(
          this.globalServiceLocation + this.globalPort + "/add/all/" + this.id,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          }
        )
        .then((response) => {
          _this.items = response.data;

          if (brisanje)
            setTimeout(() => {
              serverBus.$emit("clear_adding");
            }, 500);

          

          if (_this.id_tank_phase_wine_blend !== 0) {
            let ind = -1;
            ind = _this.items.findIndex(
              (x) => x.id === _this.id_tank_phase_wine_blend
            );

            if (ind >= 0) {
              _this.editItem(_this.items[ind]);
            }
          }
        })
        .catch((e) => {
          // // console.log(e.response);

          if (!e.response) {
            alert(
              this.$t("error.message")
            );
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  // // console.log(result);
                  // // console.log("Novi token - " + localStorage.getItem("user-token"));

                  this.$http
                    .get(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/add/all/" +
                        this.id,
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      _this.items = response.data;

                      if (brisanje)
                        setTimeout(() => {
                          serverBus.$emit("clear_adding");
                        }, 500);

                      

                      if (_this.id_tank_phase_wine_blend !== 0) {
                        let ind = -1;
                        ind = _this.items.findIndex(
                          (x) => x.id === _this.id_tank_phase_wine_blend
                        );

                        if (ind >= 0) {
                          _this.editItem(_this.items[ind]);
                        }
                      }
                    })
                    .catch((e) => {
                      // // console.log(e.response);

                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    formatImena(item) {
      let returnText = "";

      if (item.tankFromBatchInOperations !== undefined)
        if (item.tankFromBatchInOperations.length === 0) returnText = "";
        else {
          if (
            item.tankFromBatchInOperations.length % 10 === 1 &&
            item.tankFromBatchInOperations.length !== 11
          )
            returnText = item.tankFromBatchInOperations.length + " barik";
          else returnText = item.tankFromBatchInOperations.length + " barika";
        }
      else returnText = item.tankName;

      return returnText;
    },
    changeSort(column) {
      if (column !== "funkcije")
        if (this.pagination.sortBy === column) {
          this.pagination.descending = !this.pagination.descending;
        } else {
          this.pagination.sortBy = column;
          this.pagination.descending = false;
        }
    },
    editItem(item) {
      this.editedIndex = this.items.indexOf(item);
      this.editedItem = Object.assign({}, item);

      //// // console.log(item);

      serverBus.$emit("applied_adding", item);
    },
    otvoriDialogIzdtnica(item) {
      this.editedIndex = this.items.indexOf(item);
      this.editedItem = Object.assign({}, item);

      //// // console.log(item);

      serverBus.$emit("open_adding", item);
    },

    deleteItem(item) {
      const index = this.items.indexOf(item);
      confirm("Da li ste sigurni da želite obrisati izabranu operaciju?") &&
        this.deleteSifarnik(item.id);
    },
  },
  mounted() {
    // serverBus.$off("adding");

    serverBus.$on("refresh_adding", (tip_tanka) => {
      //alert("Dodavanja");
      this.id_tank_phase_wine_blend = 0;

      this.getAllSifarnik(false);
      if (tip_tanka === "15") this.headers = this.headers_sarza;

      // console.log(this.headers);

      this.sarza = tip_tanka;
    });

    serverBus.$on(
      "adding",
      (
        id,
        kolicina_vina,
        faza_mark,
        jm_mark,
        id_tank,
        tip_tanka,
        edit,
        id_tank_phase_wine_blend
      ) => {
        //alert(id);
        this.id = id;
        this.id_tank_phase_wine_blend = id_tank_phase_wine_blend;

        if (tip_tanka === "15") this.headers = this.headers_sarza;

        if (typeof edit !== "undefined") this.edit = edit;
        else this.edit = true;

        this.sarza = tip_tanka;
        this.getAllSifarnik(false);
      }
    );
  },
};
</script>
<style lang="scss" scoped>
table,
th,
td {
  padding-left: 5px;
  padding-right: 5px;
}

.v-tooltip__content {
  font-size: 14px !important;
  color: black;
  opacity: 1 !important;
  background-color: white !important;
  font-family: Roboto, sans-serif;
}
</style>